export function getFormattedDate(
  dateString: string,
  formatType: "dayMonth" | "weekday",
  timeZone: string = "UTC"
): string {
  const utcDate = new Date(dateString);

  if (formatType === "dayMonth") {
    const dayMonthFormatter = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "short",
      timeZone,
    });

    return dayMonthFormatter.format(utcDate).toUpperCase().replace(" DE", "");
  } else if (formatType === "weekday") {
    const weekdayFormatter = new Intl.DateTimeFormat("pt-BR", {
      weekday: "long",
      timeZone,
    });

    return weekdayFormatter.format(utcDate);
  }

  return "";
}
